// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MediaItem component styles */

.selected-image-container {
  position: relative;
  display: inline-block;
}

.rotate-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s, transform 0.2s;
  z-index: 5;
}

.rotate-button:hover {
  background-color: #fff;
  transform: scale(1.1);
}

.rotate-button:active {
  transform: scale(0.95);
}

.preview {
  position: relative;
}

.preview .rotate-button {
  opacity: 0;
  transition: opacity 0.2s;
}

.media-item:hover .preview .rotate-button {
  opacity: 1;
}

/* Animation for the rotation icon when clicked */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(90deg); }
}

.rotate-button.rotating i {
  animation: spin 0.3s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/MediaItem.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,wCAAwC;EACxC,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["/* MediaItem component styles */\n\n.selected-image-container {\n  position: relative;\n  display: inline-block;\n}\n\n.rotate-button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background-color: rgba(255, 255, 255, 0.8);\n  border: 1px solid #ddd;\n  border-radius: 50%;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s, transform 0.2s;\n  z-index: 5;\n}\n\n.rotate-button:hover {\n  background-color: #fff;\n  transform: scale(1.1);\n}\n\n.rotate-button:active {\n  transform: scale(0.95);\n}\n\n.preview {\n  position: relative;\n}\n\n.preview .rotate-button {\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.media-item:hover .preview .rotate-button {\n  opacity: 1;\n}\n\n/* Animation for the rotation icon when clicked */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(90deg); }\n}\n\n.rotate-button.rotating i {\n  animation: spin 0.3s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
